// reducers/roleReducer.js
export const roleReducer = (
  state = { roles: [], pending: [], rejected: [] },
  action,
) => {
  switch (action.type) {
    case "ALL_ROLES_REQUEST":
    case "PENDING_ROLES_REQUEST":
    case "CREATE_ROLE_REQUEST":
    case "UPDATE_ROLE_REQUEST":
    case "DELETE_ROLE_REQUEST":
      return { ...state, loading: true };

    case "ALL_ROLES_SUCCESS":
      return { ...state, loading: false, roles: action.payload || [] };

    case "PENDING_ROLES_SUCCESS":
      return { ...state, loading: false, pending: action.payload || [] };

    case "REJECTED_ROLES_SUCCESS":
      return { ...state, rejected: action.payload || [] };

    case "CREATE_ROLE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        roles: [...state.roles, action.payload],
      };

    // A new value typed on the Add Staff/Student form — goes to "pending".
    case "SUGGEST_ROLE_SUCCESS":
      return { ...state, success: true };

    case "APPROVE_ROLE_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        roles: [...state.roles, action.payload].sort((a, b) =>
          a.name.localeCompare(b.name),
        ),
      };

    case "REJECT_ROLE_SUCCESS":
      return {
        ...state,
        pending: state.pending.filter((d) => d.id !== action.payload.id),
        rejected: [...state.rejected, action.payload],
      };

    case "RESUBMIT_ROLE_SUCCESS":
      return {
        ...state,
        rejected: state.rejected.filter((d) => d.id !== action.payload.id),
        pending: [...state.pending, action.payload],
      };

    case "UPDATE_ROLE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        roles: state.roles.map((d) =>
          d.id === action.payload.id ? action.payload : d,
        ),
      };

    case "DELETE_ROLE_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        roles: state.roles.filter((d) => d.id !== action.payload),
        pending: state.pending.filter((d) => d.id !== action.payload),
        rejected: state.rejected.filter((d) => d.id !== action.payload),
      };

    case "ALL_ROLES_FAIL":
    case "PENDING_ROLES_FAIL":
    case "REJECTED_ROLES_FAIL":
    case "CREATE_ROLE_FAIL":
    case "SUGGEST_ROLE_FAIL":
    case "APPROVE_ROLE_FAIL":
    case "REJECT_ROLE_FAIL":
    case "RESUBMIT_ROLE_FAIL":
    case "UPDATE_ROLE_FAIL":
    case "DELETE_ROLE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };

    default:
      return state;
  }
};
